var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingWithTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 202,
    viewBox: "0 0 288 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 122.704,
    width: 34,
    height: 47.7528,
    rx: 1,
    stroke: "#585858",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126.921,
    y: 122.704,
    width: 11.7528,
    height: 47.7528,
    stroke: "#585858",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116.404,
    y: 155.491,
    width: 17.4157,
    height: 33.5955,
    transform: "rotate(-90 116.404 155.491)",
    stroke: "#585858",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.258,
    y: 158.109,
    width: 5.66292,
    height: 11.3258,
    fill: "#E1E1E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120.258,
    y: 142.334,
    width: 5.66292,
    height: 12.1348,
    fill: "#E1E1E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120.258,
    y: 126.154,
    width: 5.66292,
    height: 10.9213,
    fill: "#E1E1E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 131.989,
    y: 158.109,
    width: 5.66292,
    height: 11.3258,
    fill: "#E1E1E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.989,
    y: 142.334,
    width: 5.66292,
    height: 12.1348,
    fill: "#E1E1E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 131.989,
    y: 126.154,
    width: 5.66292,
    height: 10.9213,
    fill: "#E1E1E1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 143.315,
    y: 158.109,
    width: 5.66292,
    height: 11.3258,
    fill: "#E1E1E1"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 143.315,
    y: 142.334,
    width: 5.66292,
    height: 12.1348,
    fill: "#E1E1E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 143.315,
    y: 126.154,
    width: 5.66292,
    height: 10.9213,
    fill: "#E1E1E1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_1263_2741",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.838 185.549C263.405 183.696 269.119 175.652 269.119 166.03C269.119 156.407 263.405 148.363 255.838 146.511V39.865H249.198V26.5845H235.918V13.3041H229.194L229.277 0.0429829L222.637 0L222.554 13.304H215.997V26.5844H202.717V39.8649H196.076V68.6774C188.879 70.6324 182.138 73.8044 176.156 78.0405V46.5055H189.436V26.5848H172.836V13.3044H166.112L166.195 0.0432561L159.555 0.000273207L159.472 13.3043H152.915V26.5847H136.314V46.5054H149.595V110.316L136.314 106.996V79.7073H142.955V73.0671H123.034V53.1464H116.394V73.0671H109.753V66.4268H103.113V73.0671H96.473V59.7866H89.8328V73.0671H69.9121V79.7073H76.5523V182.718C72.5447 185.749 69.9121 190.511 69.9121 195.912C69.9121 197.034 70.0618 198.14 70.2841 199.233H38.9878V201.319H287.712V199.233H255.839L255.838 185.549ZM156.235 180.737C151.491 178.681 145.783 178.941 141.301 181.551C136.936 175.996 130.223 172.67 123.034 172.67C118.126 172.67 113.552 174.214 109.753 176.857V107.199L156.235 118.819V180.737ZM158.739 112.601L159.108 111.682C166.438 89.6417 186.381 74.5028 209.357 73.1648V188.261C205.662 186.494 201.501 185.642 197.202 186.06C193.421 177.948 185.286 172.673 176.156 172.673C171.318 172.673 166.713 174.21 162.875 176.889V113.637L158.739 112.601ZM222.636 166.03V178.494C218.781 176.662 215.996 171.795 215.996 166.03C215.996 158.706 220.465 152.75 225.957 152.75C231.448 152.75 235.917 158.706 235.917 166.03C235.917 171.794 233.132 176.661 229.277 178.494V166.03H222.636ZM215.996 193.039V181.927C217.929 183.676 220.179 184.945 222.636 185.546V199.231H220.315C219.207 196.91 217.75 194.835 215.996 193.039ZM229.277 185.549C233.333 184.556 236.84 181.771 239.237 177.932C241.634 181.774 245.141 184.556 249.197 185.549V199.232H229.277V185.549ZM262.478 166.03C262.478 171.795 259.693 176.661 255.838 178.494V166.03H249.197V178.494C245.342 176.662 242.557 171.795 242.557 166.03C242.557 158.707 247.026 152.75 252.517 152.75C258.009 152.75 262.478 158.707 262.478 166.03ZM222.636 19.9455H229.277V26.5857H222.636V19.9455ZM209.356 33.2259H242.557V39.8661H209.356V33.2259ZM202.716 46.5064H249.197V146.512C245.141 147.505 241.634 150.29 239.237 154.129C236.206 149.275 231.389 146.11 225.957 146.11C222.218 146.11 218.775 147.621 215.996 150.131V66.4267H212.676C209.3 66.4267 205.972 66.695 202.716 67.2137V46.5064ZM159.554 19.9455H166.195V26.5857H159.554V19.9455ZM142.954 33.2259H182.795V39.8661H142.954V33.2259ZM169.515 46.5064V83.4886C164.119 88.5413 159.597 94.5547 156.234 101.337V46.5079L169.515 46.5064ZM83.1917 79.7075H129.673V105.336L103.112 98.6959V184.002C102.703 184.693 102.288 185.38 101.947 186.117C101.251 186.021 100.539 185.967 99.8027 185.961C96.6886 181.813 91.7676 179.309 86.5119 179.309C85.3766 179.309 84.2649 179.425 83.1918 179.644L83.1917 79.7075ZM76.5515 195.911C76.5515 190.42 81.0201 185.951 86.5118 185.951C90.1002 185.951 93.4279 187.893 95.1946 191.02L96.2232 192.843L99.7923 192.591C100.769 192.591 101.798 192.781 102.943 193.166L106.167 194.248L107.174 190.998C109.335 184.009 115.71 179.311 123.033 179.311C129.073 179.311 134.643 182.601 137.569 187.9L139.644 191.659L142.758 188.703C146.504 185.158 152.679 185.158 156.424 188.703L159.538 191.659L161.613 187.9C164.545 182.601 170.115 179.311 176.155 179.311C183.363 179.311 189.704 183.919 191.936 190.779L192.868 193.644L195.814 192.993C202.377 191.536 208.816 194.241 212.599 199.231H77.1956C76.8161 198.163 76.5508 197.057 76.5508 195.911L76.5515 195.911Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.838 185.549C263.405 183.696 269.119 175.652 269.119 166.03C269.119 156.407 263.405 148.363 255.838 146.511V39.865H249.198V26.5845H235.918V13.3041H229.194L229.277 0.0429829L222.637 0L222.554 13.304H215.997V26.5844H202.717V39.8649H196.076V68.6774C188.879 70.6324 182.138 73.8044 176.156 78.0405V46.5055H189.436V26.5848H172.836V13.3044H166.112L166.195 0.0432561L159.555 0.000273207L159.472 13.3043H152.915V26.5847H136.314V46.5054H149.595V110.316L136.314 106.996V79.7073H142.955V73.0671H123.034V53.1464H116.394V73.0671H109.753V66.4268H103.113V73.0671H96.473V59.7866H89.8328V73.0671H69.9121V79.7073H76.5523V182.718C72.5447 185.749 69.9121 190.511 69.9121 195.912C69.9121 197.034 70.0618 198.14 70.2841 199.233H38.9878V201.319H287.712V199.233H255.839L255.838 185.549ZM156.235 180.737C151.491 178.681 145.783 178.941 141.301 181.551C136.936 175.996 130.223 172.67 123.034 172.67C118.126 172.67 113.552 174.214 109.753 176.857V107.199L156.235 118.819V180.737ZM158.739 112.601L159.108 111.682C166.438 89.6417 186.381 74.5028 209.357 73.1648V188.261C205.662 186.494 201.501 185.642 197.202 186.06C193.421 177.948 185.286 172.673 176.156 172.673C171.318 172.673 166.713 174.21 162.875 176.889V113.637L158.739 112.601ZM222.636 166.03V178.494C218.781 176.662 215.996 171.795 215.996 166.03C215.996 158.706 220.465 152.75 225.957 152.75C231.448 152.75 235.917 158.706 235.917 166.03C235.917 171.794 233.132 176.661 229.277 178.494V166.03H222.636ZM215.996 193.039V181.927C217.929 183.676 220.179 184.945 222.636 185.546V199.231H220.315C219.207 196.91 217.75 194.835 215.996 193.039ZM229.277 185.549C233.333 184.556 236.84 181.771 239.237 177.932C241.634 181.774 245.141 184.556 249.197 185.549V199.232H229.277V185.549ZM262.478 166.03C262.478 171.795 259.693 176.661 255.838 178.494V166.03H249.197V178.494C245.342 176.662 242.557 171.795 242.557 166.03C242.557 158.707 247.026 152.75 252.517 152.75C258.009 152.75 262.478 158.707 262.478 166.03ZM222.636 19.9455H229.277V26.5857H222.636V19.9455ZM209.356 33.2259H242.557V39.8661H209.356V33.2259ZM202.716 46.5064H249.197V146.512C245.141 147.505 241.634 150.29 239.237 154.129C236.206 149.275 231.389 146.11 225.957 146.11C222.218 146.11 218.775 147.621 215.996 150.131V66.4267H212.676C209.3 66.4267 205.972 66.695 202.716 67.2137V46.5064ZM159.554 19.9455H166.195V26.5857H159.554V19.9455ZM142.954 33.2259H182.795V39.8661H142.954V33.2259ZM169.515 46.5064V83.4886C164.119 88.5413 159.597 94.5547 156.234 101.337V46.5079L169.515 46.5064ZM83.1917 79.7075H129.673V105.336L103.112 98.6959V184.002C102.703 184.693 102.288 185.38 101.947 186.117C101.251 186.021 100.539 185.967 99.8027 185.961C96.6886 181.813 91.7676 179.309 86.5119 179.309C85.3766 179.309 84.2649 179.425 83.1918 179.644L83.1917 79.7075ZM76.5515 195.911C76.5515 190.42 81.0201 185.951 86.5118 185.951C90.1002 185.951 93.4279 187.893 95.1946 191.02L96.2232 192.843L99.7923 192.591C100.769 192.591 101.798 192.781 102.943 193.166L106.167 194.248L107.174 190.998C109.335 184.009 115.71 179.311 123.033 179.311C129.073 179.311 134.643 182.601 137.569 187.9L139.644 191.659L142.758 188.703C146.504 185.158 152.679 185.158 156.424 188.703L159.538 191.659L161.613 187.9C164.545 182.601 170.115 179.311 176.155 179.311C183.363 179.311 189.704 183.919 191.936 190.779L192.868 193.644L195.814 192.993C202.377 191.536 208.816 194.241 212.599 199.231H77.1956C76.8161 198.163 76.5508 197.057 76.5508 195.911L76.5515 195.911Z",
    fill: "#585858",
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-13-inside-1_1263_2741)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.436 86.3474H106.339V92.9876H103.436V86.3474Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 86.3474H93.2098V92.9876H90.3071V86.3474Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6303 86.3474H100.533V92.9876H97.6303V86.3474Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 139.469H93.2098V146.109H90.3071V139.469Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 126.189H93.2098V132.829H90.3071V126.189Z",
    fill: "#585858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 112.908H93.2098V119.549H90.3071V112.908Z",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 152.75H93.2098V159.39H90.3071V152.75Z",
    fill: "#585858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 99.6279H93.2098V106.268H90.3071V99.6279Z",
    fill: "#585858"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3071 166.03H93.2098V172.67H90.3071V166.03Z",
    fill: "#585858"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M182.796 159.39H189.436V166.03H182.796V159.39Z",
    fill: "#585858"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 159.39H176.156V166.03H169.516V159.39Z",
    fill: "#585858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.076 159.39H202.717V166.03H196.076V159.39Z",
    fill: "#585858"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.796 146.109H189.436V152.75H182.796V146.109Z",
    fill: "#585858"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 146.109H176.156V152.75H169.516V146.109Z",
    fill: "#585858"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.076 146.109H202.717V152.75H196.076V146.109Z",
    fill: "#585858"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.076 132.829H202.717V139.469H196.076V132.829Z",
    fill: "#585858"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 132.829H176.156V139.469H169.516V132.829Z",
    fill: "#585858"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M182.796 132.829H189.436V139.469H182.796V132.829Z",
    fill: "#585858"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 119.548H176.156V126.189H169.516V119.548Z",
    fill: "#585858"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.076 119.548H202.717V126.189H196.076V119.548Z",
    fill: "#585858"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M182.796 119.548H189.436V126.189H182.796V119.548Z",
    fill: "#585858"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.076 106.268H202.717V112.908H196.076V106.268Z",
    fill: "#585858"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.796 106.268H189.436V112.908H182.796V106.268Z",
    fill: "#585858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.516 106.268H176.156V112.908H169.516V106.268Z",
    fill: "#585858"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.796 92.9875H189.436V99.6278H182.796V92.9875Z",
    fill: "#585858"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M121.649 86.2524H124.552V92.8416H121.649V86.2524Z",
    fill: "#585858"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.038 86.2524H112.941V92.8416H110.038V86.2524Z",
    fill: "#585858"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.844 86.2524H118.746V92.8416H115.844V86.2524Z",
    fill: "#585858"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5165 138.966H100.419V145.555H97.5165V138.966Z",
    fill: "#585858"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5165 125.787H100.419V132.376H97.5165V125.787Z",
    fill: "#585858"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5165 112.609H100.419V119.198H97.5165V112.609Z",
    fill: "#585858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5165 152.144H100.419V158.733H97.5165V152.144Z",
    fill: "#585858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5165 99.4307H100.419V106.02H97.5165V99.4307Z",
    fill: "#585858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5165 165.322H100.419V171.911H97.5165V165.322Z",
    fill: "#585858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M196.076 92.9875H202.717V99.6278H196.076V92.9875Z",
    fill: "#585858"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 66.4266H229.278V73.0669H222.637V66.4266Z",
    fill: "#585858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 66.4266H242.558V73.0669H235.918V66.4266Z",
    fill: "#585858"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 79.707H242.558V86.3473H235.918V79.707Z",
    fill: "#585858"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 79.707H229.278V86.3473H222.637V79.707Z",
    fill: "#585858"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 92.9875H229.278V99.6278H222.637V92.9875Z",
    fill: "#585858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 92.9875H242.558V99.6278H235.918V92.9875Z",
    fill: "#585858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 106.268H242.558V112.908H235.918V106.268Z",
    fill: "#585858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 106.268H229.278V112.908H222.637V106.268Z",
    fill: "#585858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 119.548H229.278V126.189H222.637V119.548Z",
    fill: "#585858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 119.548H242.558V126.189H235.918V119.548Z",
    fill: "#585858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 132.829H242.558V139.469H235.918V132.829Z",
    fill: "#585858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 132.829H229.278V139.469H222.637V132.829Z",
    fill: "#585858"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M235.918 53.1461H242.558V59.7863H235.918V53.1461Z",
    fill: "#585858"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 53.1461H229.278V59.7863H222.637V53.1461Z",
    fill: "#585858"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M209.357 53.1461H215.997V59.7863H209.357V53.1461Z",
    fill: "#585858"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 66.5215H233.817V73.1617H229.02V66.5215Z",
    fill: "#DFDFDF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 66.5215H246.827V73.1617H242.03V66.5215Z",
    fill: "#DFDFDF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 79.802H246.827V86.4422H242.03V79.802Z",
    fill: "#DFDFDF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 79.802H233.817V86.4422H229.02V79.802Z",
    fill: "#DFDFDF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 93.0824H233.817V99.7226H229.02V93.0824Z",
    fill: "#DFDFDF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 93.0824H246.827V99.7226H242.03V93.0824Z",
    fill: "#DFDFDF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 106.363H246.827V113.003H242.03V106.363Z",
    fill: "#DFDFDF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 106.363H233.817V113.003H229.02V106.363Z",
    fill: "#DFDFDF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 119.643H233.817V126.284H229.02V119.643Z",
    fill: "#DFDFDF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 119.643H246.827V126.284H242.03V119.643Z",
    fill: "#DFDFDF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 132.924H246.827V139.564H242.03V132.924Z",
    fill: "#DFDFDF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 132.924H233.817V139.564H229.02V132.924Z",
    fill: "#DFDFDF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 53.241H246.827V59.8812H242.03V53.241Z",
    fill: "#DFDFDF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02 53.241H233.817V59.8812H229.02V53.241Z",
    fill: "#DFDFDF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M215.631 52.8616H220.428V59.5018H215.631V52.8616Z",
    fill: "#DFDFDF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M173.784 130.714L161.263 118.125V179.216L173.784 174.773V130.714Z",
    fill: "#C4C4C4",
    fillOpacity: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M219.317 82.9956L214.385 69.557V154.931L219.317 148.607V82.9956Z",
    fill: "#C4C4C4",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3226 124.743C72.7248 125.446 79.9322 138.656 79.9322 155.8C79.9322 172.943 72.4911 186.856 63.3226 186.856C61.9639 186.856 57.1336 187.029 59.6505 185.287C62.1673 183.544 73.4748 166.165 73.4748 151.562C73.4748 134.419 53.9204 124.041 63.3226 124.743V124.743Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7371 200.255C16.2988 200.255 16.6737 199.877 16.6737 199.31V196.476C22.3857 195.91 26.8802 190.998 26.8802 185.048C26.8802 178.719 21.8241 173.618 15.5496 173.618C9.27575 173.618 4.2189 178.718 4.2189 185.048C4.2189 191.093 8.90086 196.099 14.8938 196.477V199.311C14.8004 199.782 15.2687 200.255 15.737 200.255L15.7371 200.255ZM5.99895 185.048C5.99895 179.758 10.3067 175.508 15.4563 175.508C20.6067 175.508 25.0077 179.758 25.0077 185.048C25.0077 189.959 21.3558 194.021 16.6738 194.587V192.037L21.2623 187.408C21.6366 187.031 21.6366 186.464 21.2623 186.086C20.888 185.709 20.3256 185.709 19.9514 186.086L16.6737 189.392V183.253C16.6737 182.687 16.2994 182.308 15.737 182.308C15.1753 182.308 14.8004 182.686 14.8004 183.253V189.392L11.5227 186.086C11.1484 185.709 10.586 185.709 10.2117 186.086C9.83747 186.464 9.83747 187.031 10.2117 187.408L14.8002 192.037V194.682C9.93149 194.21 5.99865 190.054 5.99865 185.048L5.99895 185.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0087 200.194C57.5704 200.194 57.9453 199.816 57.9453 199.249V185.932C66.6534 185.082 73.3954 171.953 73.3954 155.329C73.3954 138.138 66.1851 124.725 57.0086 124.725C51.6708 124.725 46.8021 129.448 43.7118 137.382C40.5283 134.832 36.5954 133.321 32.1944 133.321C21.9879 133.321 13.6538 141.727 13.6538 152.023C13.6538 162.13 21.6135 170.347 31.5389 170.63V199.155C31.5389 199.722 31.9132 200.1 32.4756 200.1C33.0373 200.1 33.4122 199.723 33.4122 199.155L33.4116 170.63C36.5017 170.441 39.4045 169.402 41.9329 167.796C44.4613 178.281 49.7984 185.176 55.8853 185.837V199.155C56.0721 199.722 56.4464 200.194 57.0081 200.194L57.0087 200.194ZM33.5052 163.451L41.4649 155.422C41.8392 155.045 41.8392 154.478 41.4649 154.1C41.0906 153.723 40.5282 153.723 40.154 154.1L33.5053 160.807V148.811C33.5053 148.244 33.131 147.866 32.5686 147.866C32.0069 147.866 31.6319 148.244 31.6319 148.811V160.807L24.9832 154.1C24.609 153.723 24.0466 153.723 23.6723 154.1C23.298 154.478 23.298 155.045 23.6723 155.422L31.632 163.451V168.836C22.7364 168.552 15.6194 161.09 15.6194 152.117C15.6194 142.861 23.1107 135.304 32.2871 135.304C41.4636 135.304 48.9549 142.861 48.9549 152.117C48.9549 160.901 42.1194 168.174 33.5981 168.836L33.5987 163.451H33.5052ZM43.7117 166.663C48.0195 163.262 50.7347 157.973 50.7347 152.022C50.7347 146.827 48.5811 142.104 45.2101 138.704C47.9253 131.147 52.3265 126.614 57.0085 126.614C64.9681 126.614 71.5227 139.554 71.5227 155.328C71.5227 170.535 65.5298 183.003 57.9452 184.042V161.467C57.9452 160.901 57.5709 160.522 57.0086 160.522C56.4468 160.522 56.0719 160.9 56.0719 161.467V184.042C50.6413 183.381 45.8661 176.674 43.7119 166.662L43.7117 166.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4961 127.845C31.0468 127.845 33.1148 126.064 33.1148 123.868C33.1148 121.979 31.5833 120.398 29.5335 119.992C29.6066 119.72 29.6507 119.436 29.6507 119.145C29.6507 117.086 27.712 115.416 25.3207 115.416C24.651 115.416 24.0194 115.556 23.4534 115.789C22.2895 114.648 20.5843 113.925 18.6815 113.925C15.1741 113.925 12.3309 116.373 12.3309 119.393C12.3309 119.477 12.3355 119.559 12.34 119.642C10.9426 120.444 10.0215 121.816 10.0215 123.371C10.0215 125.842 12.3478 127.845 15.2175 127.845H28.4961Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6084 135.026C12.4759 135.026 13.1799 135.737 13.1799 136.612C13.1799 137.487 12.4759 138.197 11.6084 138.197C10.7409 138.197 10.0368 137.487 10.0368 136.612C10.0368 135.737 10.7409 135.026 11.6084 135.026Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7979 115.409C56.7979 117.389 55.2056 118.974 53.2674 118.974C51.3292 118.974 49.7369 117.389 49.7369 115.409C49.7369 113.429 51.3292 111.844 53.2674 111.844C55.2056 111.844 56.7979 113.429 56.7979 115.409Z",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9999 37.7042C71.8658 37.7042 75 35.0181 75 31.7041C75 28.8553 72.6789 26.4694 69.5722 25.8566C69.683 25.4467 69.7498 25.018 69.7498 24.5793C69.7498 21.4728 66.8116 18.9543 63.1874 18.9543C62.1724 18.9543 61.2151 19.1641 60.3572 19.5167C58.5933 17.7942 56.0088 16.7042 53.1249 16.7042C47.8091 16.7042 43.5 20.398 43.5 24.9542C43.5 25.0808 43.5071 25.204 43.5138 25.3293C41.3959 26.5391 40 28.609 40 30.9543C40 34.6823 43.5257 37.7042 47.8749 37.7042H67.9999Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6068 23.5957L61.3272 24.6302L62.3786 24.8377C65.1348 25.3814 67 27.4439 67 29.7041C67 32.3267 64.4637 34.7042 60.9999 34.7042H40.8749C36.9278 34.7042 34 31.9909 34 28.9543C34 27.0303 35.1453 25.2626 37.0098 24.1976L37.5454 23.8917L37.5123 23.2758L37.5118 23.2662C37.505 23.1384 37.5 23.0463 37.5 22.9542C37.5 19.0893 41.2113 15.7042 46.1249 15.7042C48.7599 15.7042 51.09 16.7004 52.6585 18.2322L53.129 18.6917L53.7373 18.4416C54.4824 18.1354 55.311 17.9543 56.1874 17.9543C59.4095 17.9543 61.7498 20.1641 61.7498 22.5793C61.7498 22.9165 61.6984 23.2569 61.6068 23.5957Z",
    fill: "white",
    stroke: "#585858",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingWithTree);
export default __webpack_public_path__ + "static/media/buildingWithTree.14f7fe9326f261028959a77ff1854a08.svg";
export { ForwardRef as ReactComponent };